import React from "react";
import { Route, Routes } from "react-router-dom";
import BillingDrift from "./pages/Company/BillingDrift";
import PaygDrift from "./pages/Company/PaygDrift";
import PaygInvoices from "./pages/Company/PaygInvoices";
import Companies from "./pages/Company/Companies";
import Dashboard from "./pages/Dashboard/Dashboard";
import DetailedDashboard from "./pages/Dashboard/DetailedDashboard";
import ForgotPassword from "./pages/ForgotPassword";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Users from "./pages/User/Users";
import UsersLog from "./pages/UserLog/UsersLog";
import PricingConfig from "./pages/PricingConfig/PricingConfig";

const Markup = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/detailed-dashboard" element={<DetailedDashboard />} />
      <Route path="/company" element={<Companies />} />
      <Route path="/billing-drift" element={<BillingDrift />} />
      <Route path="/payg-drift" element={<PaygDrift />} />
      <Route path="/payg-invoices" element={<PaygInvoices />} />
      <Route path="/users" element={<Users />} />
      <Route path="/users-log" element={<UsersLog />} />
      <Route path="/pricing-config" element={<PricingConfig />} />
      <Route path="*" element={<Login />} />
    </Routes>
  );
};

export default Markup;
